// ⚠️ FICHIER ENGENDRÉ — NE PAS ÉDITER À LA MAIN.
// Source : lib/operateur-leviers.js + lib/leviers/*.js
// Régénérer : node scripts/generer-miroir-leviers.js
// Pourquoi ce doublon : CRA/webpack refuse les imports hors de src/ (Jest, lui,
// les accepte — d'où le risque de tests verts sur un build cassé).
// lib/leviers/operateur.js — LES LEVIERS DE SA PROPRE MÉCANIQUE ET DES VEILLES.
//
// Les quatre premiers leviers du parc, écrits le 2026-09-08/09. Déplacés ici
// depuis `lib/operateur-leviers.js` (move byte-identique) le 2026-09-09, quand
// le registre a été éclaté par famille pour être rempli en parallèle.
//
// ⚠️ Les quatre sont `autonome: true` — GO Dimitri du 2026-09-09 : « aucun ne
// sort de chez moi, aucun ne touche l'argent ». Le raisonnement des quatre
// questions voyage avec chaque entrée, ci-dessous.

// ══ LES ONZE GESTES DE SA PROPRE MÉCANIQUE — TOUS ÉCARTÉS, E5 ═════════════
//
// Balayés le 2026-09-12, sur le CODE de `lib/operateur-handlers.js`, pas sur
// leur nom. Ils forment un bloc homogène : ce sont les boutons de l'écran
// « Opérateur », c'est-à-dire les commandes que Dimitri a sur LUI. E5 les nomme
// en toutes lettres — « rien qui laisse l'opérateur agir SUR LUI-MÊME (se
// relancer, régler sa propre autonomie, refuser ses propres propositions,
// ouvrir sa vanne d'envoi réel) ».
//
// ⚠️ ET CE N'EST PAS UNE QUESTION DE RISQUE TECHNIQUE. Les onze handlers sont
// propres : rowcount-checkés, transitions gardées (`.eq('statut', attendu)`),
// acteur pris du JWT et jamais du corps. Plusieurs passeraient E1→E4 sans une
// ride. C'est une question de QUI DÉCIDE — et un bras droit qui compose
// l'intention de lever ses propres freins n'est plus tenu par rien d'autre que
// la vigilance de celui qui clique. Dimitri verrait « relancer l'opérateur »
// sur une carte ; ce qu'il approuverait, c'est que l'opérateur ait demandé.
//
//   · operateur_etat_toggle      — LE coupe-circuit (`en_marche`). Se relancer
//     lui-même est le cas d'école d'E5 ; et à l'arrêt, `claim` refuse déjà tout
//     (409 `a_l_arret`) — un levier qui rouvre la vanne qui le retient.
//   · operateur_autonomie_set    — règle le curseur demande/propose/fait_seul
//     de ses propres actes (`operateur_memoire` cle `autonomie:*`). E5 mot pour
//     mot : « régler sa propre autonomie ».
//   · operateur_proposition_claim / _confirm / _refuse — décider du sort de SES
//     propositions. E5 mot pour mot : « refuser ses propres propositions ». Et
//     `confirm` est ce qui FAIT PARTIR le message : le proposer reviendrait à
//     ce que la proposition s'auto-valide d'un clic dont Dimitri croirait qu'il
//     porte sur autre chose.
//   · operateur_regle_toujours   — écrit une règle permanente, soit dans les
//     instructions IA de CHAQUE logement éligible, soit (flag mémoire allumé)
//     en `operateur_memoire`. Il se réécrit sa propre consigne de fond.
//   · operateur_memoire_decide   — garder / verrouiller / oublier / TOUT
//     oublier ses propres règles retenues. `tout_oublier` tombale toutes les
//     règles vivantes d'un appel : l'effet déborde largement son libellé, et il
//     s'ajoute à E5.
//   · operateur_plan_toggle / _plan_decide — allumer, éteindre, accepter ou
//     refuser ses propres passages planifiés. Se donner du travail récurrent,
//     ou s'en retirer, sans que personne d'autre ne l'ait voulu.
//   · operateur_acte_defaire     — défaire un de SES actes déjà posés. Le geste
//     va dans le bon sens (il annule), mais il reste un geste sur son propre
//     journal : le « ↩ Défaire » est la main de Dimitri sur ce qu'il relit,
//     jamais une proposition de l'intéressé.
//   · operateur_conversation     — c'est LUI. L'action par laquelle Dimitri lui
//     parle n'écrit rien (aucune table, aucun état), donc rien à constater →
//     E2 tombe avant même E5 ; et un levier qui pointe l'endpoint qui l'a
//     composé est une boucle, pas un geste.
//
// ⚠️ E5 EST « EN ATTENTE D'ARBITRAGE DIMITRI » depuis le 2026-09-08
// (`lib/operateur-leviers.js`). Elle reste appliquée telle quelle ici : ces
// onze-là sont le cœur même de ce qu'elle protège, et si elle devait un jour
// se relâcher, c'est par eux qu'il faudrait commencer À DISCUTER — pas par eux
// qu'il faudrait commencer à ouvrir sans le dire.

const LEVIERS_OPERATEUR = Object.freeze({
  veille_silence: {
    ecran: "operateur",
    endpoint: "/api/beds24-mapping",
    action: "veille_silence",
    args_autorises: ["famille", "cle", "periode", "motif", "retirer"],
    // ⚠️ AUCUNE LISTE DE VALEURS ICI, ET C'EST DÉLIBÉRÉ. J'ai commencé par y
    // recopier les dix types de `veille-manques`, avant de mesurer : les
    // alertes viennent AUSSI de `veille-cautions` (« immobilisee »,
    // « remboursement_en_retard », « rendue_sans_prevenir »…), et la colonne
    // `veille_silences.famille` est un TEXTE LIBRE — le serveur ne ferme rien.
    // Une liste incomplète aurait produit le défaut INVERSE de celui qu'on
    // venait de corriger : des refus injustifiés sur des alertes réelles, et un
    // opérateur qui dit « je ne sais pas faire » alors qu'il sait.
    // ⚠️ ON NE FERME QUE CE QUE LE SERVEUR FERME.
    titre: "Taire une alerte",
    constatable:
      "l'alerte quitte la liste principale et apparaît dans les alertes tues, avec son motif",
    sujet: "operateur",
    cout: ["rien"],
    ou_ca_part: ["personne"],
    sans_retour: null, // `retirer: true` défait — et un silence mensuel expire seul
    ne_fait_pas:
      "il ne règle rien : l'alerte est TUE, pas traitée. Ce qu'elle signalait reste vrai, et elle reviendra si le fait qui l'a produite se reproduit.",
    apercu: {
      lecture: "veille_silences_lire",
      depend_de: ["famille", "cle", "periode"],
      // La lecture rend les silences DÉJÀ posés sur la famille, et reconnaît
      // celui qui vise exactement la même alerte (famille, clé, période).
      // ⚠️ `x-apercu-version`, PAS `x-cfg-version` — ce geste n'écrit pas le
      // blob de configuration. Le jeton prouve QUE LA CARTE A LU (executerGeste
      // refuse de partir sans lui) ; l'écriture, elle, ne le vérifie pas encore
      // (lot à part, avec l'écran — cf. lib/apercus-messages-handlers.js).
      jeton: "x-apercu-version",
    },
    dit_comme: [
      "Cette alerte, je l'ai déjà traitée ailleurs",
      "Arrête de me remonter ça",
      "Tais cette alerte, c'est réglé",
    ],
    vague: 1,
    motif_requis: true,
    // Le nom sous lequel CE handler attend le motif. Sans lui, celui que
    // Dimitri écrit part dans le vide (2026-09-09).
    motif_champ: "motif",
    // 1 ✔ (`retirer: true` défait) · 2 ✔ (rien ne sort) · 3 ✔ (la ligne bouge
    // à l'écran) · 4 ✔ (aucun champ numérique). Et le silence mensuel EXPIRE
    // tout seul : même oublié, il se répare au changement de mois.
    autonome: true,
  },
  signalement_voyageur_traiter: {
    ecran: "operateur",
    endpoint: "/api/beds24-mapping",
    action: "signalement_voyageur_traiter",
    args_autorises: ["famille", "id", "issue"],
    // ⚠️ Valeurs RECOPIÉES de la liste fermée du serveur. Sans elles, le
    // modèle compose du plausible — il l'a fait le 2026-09-09 en prod
    // (« adresse » pour « adresse_complete ») — et la carte s'affiche
    // avant d'échouer sous le clic.
    args_valeurs: {
      famille: ["sejour", "etat_des_lieux"],
    },
    titre: "Marquer un signalement comme traité",
    constatable: "la ligne quitte « Ce qui vous attend »",
    sujet: "voyageur",
    cout: ["rien"],
    ou_ca_part: ["personne"],
    sans_retour: null, // le signalement reste en base et se rouvre
    ne_fait_pas:
      "il ne répond pas au voyageur et ne le prévient pas : il range la ligne de notre côté, le signalement reste en base",
    apercu: {
      lecture: "signalement_lire",
      depend_de: ["famille", "id"],
      // ⚠️ `x-apercu-version`, PAS `x-cfg-version` — ce geste n'écrit pas le
      // blob de configuration. Le jeton prouve QUE LA CARTE A LU (executerGeste
      // refuse de partir sans lui) ; l'écriture, elle, ne le vérifie pas encore
      // (lot à part, avec l'écran — cf. lib/apercus-messages-handlers.js).
      jeton: "x-apercu-version",
    },
    dit_comme: [
      "Ce signalement est traité",
      "J'ai réglé ce que le voyageur avait remonté",
      "Enlève ça de ce qui m'attend",
    ],
    vague: 1,
    motif_requis: false,
    // 1 ✔ · 2 ✔ · 3 ✔ · 4 ✔ — le signalement reste en base, seul son état
    // change, et il se rouvre.
    autonome: true,
  },
  inbox_ia_escalation_resolve: {
    ecran: "messages",
    endpoint: "/api/beds24-mapping",
    action: "inbox_ia_escalation_resolve",
    args_autorises: ["id", "thread_id"],
    titre: "Clore une escalade du copilote",
    constatable: "la carte quitte la file d'escalades, la pastille retombe",
    sujet: "messages",
    cout: ["rien"],
    // L'escalade est un objet INTERNE : la clore n'écrit rien vers le voyageur.
    ou_ca_part: ["personne"],
    sans_retour: null, // l'escalade reste en base, seul son état change
    ne_fait_pas:
      "il ne répond PAS au voyageur : sa question reste sans réponse. Répondre est un autre geste. Clore sans répondre laisse quelqu'un attendre.",
    apercu: {
      lecture: "inbox_fil_lire",
      depend_de: ["id", "thread_id"],
      // L'un OU l'autre : la lecture dérive le fil de l'escalade quand seul
      // `id` est composé — un geste qui marchait ne meurt pas d'avoir un aperçu.
      // ⚠️ `x-apercu-version`, PAS `x-cfg-version` — ce geste n'écrit pas le
      // blob de configuration. Le jeton prouve QUE LA CARTE A LU (executerGeste
      // refuse de partir sans lui) ; l'écriture, elle, ne le vérifie pas encore
      // (lot à part, avec l'écran — cf. lib/apercus-messages-handlers.js).
      jeton: "x-apercu-version",
    },
    dit_comme: [
      "Cette escalade est réglée",
      "Enlève cette alerte de l'assistant",
      "J'ai repris la main là-dessus, ferme-la",
    ],
    vague: 2,
    motif_requis: false,
    // 1 ✔ · 2 ✔ (l'escalade est un objet INTERNE : clore n'écrit rien vers le
    // voyageur) · 3 ✔ · 4 ✔.
    autonome: true,
  },
  divulgation_regle_set: {
    ecran: "logements",
    endpoint: "/api/beds24-mapping",
    action: "divulgation_regle_set",
    args_autorises: ["logementId", "champ", "portee_type", "motif"],
    // ⚠️ RECOPIÉ DE `lib/divulgation-resolve.js` (CHAMPS) et de
    // `lib/divulgation-handlers.js` (PORTEES_CABLEES) — les listes fermées du
    // serveur. Sans elles, le modèle compose « adresse » là où le serveur
    // attend « adresse_complete » : c'est arrivé en prod le 2026-09-09, sur un
    // geste qui se serait affiché puis aurait échoué sous le clic.
    args_valeurs: {
      champ: [
        "wifi_code",
        "box_code",
        "door_code",
        "adresse_complete",
        "instructions_acces_batiment",
      ],
      portee_type: ["logement", "partout"],
    },
    titre: "Restreindre ce que le copilote divulgue",
    constatable: "la règle apparaît dans la fiche du logement",
    sujet: "messages",
    onglet: "savoir",
    cout: ["rien"],
    ou_ca_part: ["personne"],
    sans_retour: null, // `divulgation_regle_clear` défait la règle
    // ⚠️ LA TABLE NE SAIT QUE RESTREINDRE — mais la restriction n'est qu'un
    // PLAFOND : ce que le copilote dit dépend aussi du scrubber et du contexte.
    ne_fait_pas:
      "il n'ouvre jamais une porte : la table ne sait que restreindre. Et il ne rattrape rien — ce que le copilote a déjà envoyé est parti.",
    apercu: {
      lecture: "divulgation_regles_lire",
      // ⚠️ `portee_type` DANS `depend_de` (revue adverse #1444). Une règle
      // « partout » et une règle de CE logement peuvent viser le MÊME champ :
      // sans la portée, la carte montrait l'une et le clic touchait l'autre.
      // La même correction a été passée sur le geste inverse
      // (`divulgation_regle_clear`, #1442).
      depend_de: ["logementId", "champ", "portee_type"],
      // ⚠️ `x-apercu-version`, PAS `x-cfg-version` — ce geste n'écrit pas le
      // blob de configuration. Le jeton prouve QUE LA CARTE A LU (executerGeste
      // refuse de partir sans lui) ; l'écriture, elle, ne le vérifie pas encore
      // (lot à part, avec l'écran — cf. lib/apercus-messages-handlers.js).
      jeton: "x-apercu-version",
    },
    dit_comme: [
      "L'assistant ne doit pas donner l'adresse complète du Cocon",
      "Empêche-le de donner le code de la porte",
      "Ne le laisse plus dire le mot de passe du wifi",
    ],
    vague: 2,
    // La table ne sait que RESTREINDRE : un opérateur qui propose ici ne peut
    // que se serrer la vis. C'est la seule famille 100 % éligible du parc.
    motif_requis: false,
    // 1 ✔ (`divulgation_regle_clear`) · 2 ✔ · 3 ✔ · 4 ✔.
    // ⚠️ Et le pire cas est BORNÉ PAR LA TABLE : elle ne peut que fermer une
    // porte, jamais en ouvrir une. Un geste de travers rend le copilote plus
    // prudent — c'est le seul levier dont l'erreur va dans le bon sens.
    autonome: true,
  },
});

// ══ CE QUI N'EST PAS UN LEVIER : `operateur_proposition_confirm` (2026-09-13) ═
//
// L'action existe et n'est pas au registre — et elle N'Y ENTRERA PAS. Ce n'est
// pas un risque, c'est une confusion de NIVEAU, lue dans le code :
//   · `src/lib/geste-executer.js` étape 3 : `confirm` est la TRACE posée APRÈS
//     que le levier a été appelé par le navigateur de Dimitri. Elle ne reçoit
//     qu'une référence opaque (`handleOperateurPropositionConfirm` : « il ne
//     reçoit qu'une référence, jamais de quoi agir ») ;
//   · le registre sert à COMPOSER un geste. Composer « confirme la proposition
//     X » ferait passer une ligne en `acceptee` SANS que le geste ait eu lieu
//     — et le journal dirait « parti » sur un envoi qui n'a jamais existé. Le
//     pire des défauts silencieux : plausible, daté, signé.
//   · et c'est E5, nommément : « refuser ses propres propositions » est déjà
//     cité ; confirmer est son jumeau. L'opérateur n'agit pas sur sa propre
//     file.
// Même raisonnement pour `operateur_proposition_claim` et `_refuse`.

// ══ LES BOOLÉENS DE CETTE FAMILLE, EN MOTS — `levier.argument` ════════════
//
// F5 (03/10/2026) : déplacées telles quelles de `lib/operateur-leviers.js`,
// qui les rassemble (la règle et ses gardes sont écrites là-bas, au-dessus de
// `NOMS_BOOLEENS`). Une phrase se déclare ICI, à côté de son levier, et nulle
// part ailleurs.
const BOOLEENS_LIBELLES = Object.freeze({
  "veille_silence.retirer": {
    oui: "Remettre l'alerte en liste",
    non: "Taire l'alerte",
  },
});

module.exports = { LEVIERS_OPERATEUR, BOOLEENS_LIBELLES };
